const pathnames = {
  index: '/account',
  bookings: {
    pathname: '/bookings',
  },
  wallet: {
    pathname: '/wallet',
  },
  settings: {
    pathname: '/settings',
  },
  accountDeletion: {
    pathname: `/delete-account`,
  },
  directBookings: {
    pathname: '/direct-bookings',
  },
  rewards: {
    pathname: '/rewards',
  },
  referral: {
    pathname: '/referral',
  },
  cancel: {
    pathname: '/cancel',
  },
  personalDetails: {
    pathname: '/personal-details',
  },
  accountRecover: {
    pathname: '/recover',
  },
  register: {
    pathname: '/register',
  },
  login: {
    pathname: '/login',
  },
};

const routes = {
  BOOKINGS_PATH: `${pathnames.index}${pathnames.bookings.pathname}`,
  WALLET_PATH: `${pathnames.index}${pathnames.wallet.pathname}`,
  SETTINGS_PATH: `${pathnames.index}${pathnames.settings.pathname}`,
  ACCOUNT_DELETION_PATH: `${pathnames.index}${pathnames.settings.pathname}${pathnames.accountDeletion.pathname}`,
  REWARDS_PATH: `${pathnames.index}${pathnames.rewards.pathname}`,
  REFERRAL_PATH: `${pathnames.index}${pathnames.referral.pathname}`,
  PERSONAL_AREA_PATH: `${pathnames.index}`,
  CANCELLATION_PATH: `${pathnames.index}${pathnames.cancel.pathname}`,
  DIRECT_BOOKINGS_PATH: `${pathnames.index}${pathnames.directBookings.pathname}`,
  PERSONAL_DETAILS_PATH: `${pathnames.index}${pathnames.personalDetails.pathname}`,
  ACCOUNT_RECOVER_PATH: `${pathnames.index}${pathnames.accountRecover.pathname}`,
  REGISTER_PATH: `${pathnames.index}${pathnames.register.pathname}`,
  LOGIN_PATH: `${pathnames.index}${pathnames.login.pathname}`,
};

module.exports = {
  routes,
};
